import { render, staticRenderFns } from "./salarySuccessDtl.vue?vue&type=template&id=fb575888&scoped=true&"
import script from "./salarySuccessDtl.vue?vue&type=script&lang=js&"
export * from "./salarySuccessDtl.vue?vue&type=script&lang=js&"
import style0 from "./salarySuccessDtl.vue?vue&type=style&index=0&id=fb575888&prod&lang=scss&scoped=true&"
import style1 from "./salarySuccessDtl.vue?vue&type=style&index=1&id=fb575888&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb575888",
  null
  
)

export default component.exports